export default __webpack_public_path__ + "static/media/pickaxe.005e2c00.png";